import React from "react"
import FlexView from 'react-flexview/lib'
import { isMobile } from "react-device-detect"

export const TotalPrice = ({ totalPrice }) => {
    const formattedPrice = totalPrice ? `$${totalPrice.toFixed(2)}` : 'N/A'
    
    return (
            <FlexView column={true} marginTop={15} className="space-between margin-bottom-basic">
                <div className="text-body bold black">Total Price</div>
                <div className="black margin-top-small text-small">
                    {formattedPrice}
                </div>
            </FlexView>
    )
}